import { c as _c } from "react/compiler-runtime";
import type { ApiNodeData, NewNodeKind, NodeDataUpdate } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import useGetNewNodeContext from '@/components/playbook-builder/components/add-node-dialog/hooks/use-get-new-node-context';
export const useTranslateOperation = () => {
  const $ = _c(169);
  const {
    t
  } = useTranslation("playbook-builder");
  const {
    getNodeContext
  } = useGetNewNodeContext();
  let t0;
  if ($[0] !== t) {
    t0 = t(_temp);
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t(_temp2);
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t(_temp3);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t(_temp4);
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp5);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp6);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp7);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(_temp8);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t(_temp9);
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp10);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp11);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t(_temp12);
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t(_temp13);
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t(_temp14);
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t(_temp15);
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t(_temp16);
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t(_temp17);
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t(_temp18);
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t(_temp19);
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t) {
    t19 = t(_temp20);
    $[38] = t;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t) {
    t20 = t(_temp21);
    $[40] = t;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== t) {
    t21 = t(_temp22);
    $[42] = t;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== t) {
    t22 = t(_temp23);
    $[44] = t;
    $[45] = t22;
  } else {
    t22 = $[45];
  }
  let t23;
  if ($[46] !== t) {
    t23 = t(_temp24);
    $[46] = t;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t) {
    t24 = t(_temp25);
    $[48] = t;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t) {
    t25 = t(_temp26);
    $[50] = t;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t) {
    t26 = t(_temp27);
    $[52] = t;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t0 || $[55] !== t1 || $[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t13 || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== t17 || $[64] !== t18 || $[65] !== t19 || $[66] !== t2 || $[67] !== t20 || $[68] !== t21 || $[69] !== t22 || $[70] !== t23 || $[71] !== t24 || $[72] !== t25 || $[73] !== t26 || $[74] !== t3 || $[75] !== t4 || $[76] !== t5 || $[77] !== t6 || $[78] !== t7 || $[79] !== t8 || $[80] !== t9) {
    t27 = {
      custom_document: t0,
      collect_custom_data: t1,
      identity_data: t2,
      business_data: t3,
      conditional: t4,
      rules: t5,
      identity_document: t6,
      selfie: t7,
      verification_check: t8,
      action: t9,
      branch: t10,
      external_api: t11,
      bank_link: t12,
      authentication: t13,
      collect_card_data: t14,
      assign_data: t15,
      common_expression: t16,
      code_exec: t17,
      document_extraction: t18,
      add_default_rules: t19,
      remove_rules_for_category: t20,
      prerequisite: t21,
      output: t22,
      complete: t23,
      ai_research: t24,
      ai_decision: t25,
      verified_prefill: t26
    };
    $[54] = t0;
    $[55] = t1;
    $[56] = t10;
    $[57] = t11;
    $[58] = t12;
    $[59] = t13;
    $[60] = t14;
    $[61] = t15;
    $[62] = t16;
    $[63] = t17;
    $[64] = t18;
    $[65] = t19;
    $[66] = t2;
    $[67] = t20;
    $[68] = t21;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
    $[72] = t25;
    $[73] = t26;
    $[74] = t3;
    $[75] = t4;
    $[76] = t5;
    $[77] = t6;
    $[78] = t7;
    $[79] = t8;
    $[80] = t9;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  const updateTranslations = t27;
  let t28;
  if ($[82] !== t) {
    t28 = t(_temp28);
    $[82] = t;
    $[83] = t28;
  } else {
    t28 = $[83];
  }
  let t29;
  if ($[84] !== t) {
    t29 = t(_temp29);
    $[84] = t;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  let t30;
  if ($[86] !== t) {
    t30 = t(_temp30);
    $[86] = t;
    $[87] = t30;
  } else {
    t30 = $[87];
  }
  let t31;
  if ($[88] !== t) {
    t31 = t(_temp31);
    $[88] = t;
    $[89] = t31;
  } else {
    t31 = $[89];
  }
  let t32;
  if ($[90] !== t) {
    t32 = t(_temp32);
    $[90] = t;
    $[91] = t32;
  } else {
    t32 = $[91];
  }
  let t33;
  if ($[92] !== t) {
    t33 = t(_temp33);
    $[92] = t;
    $[93] = t33;
  } else {
    t33 = $[93];
  }
  let t34;
  if ($[94] !== t) {
    t34 = t(_temp34);
    $[94] = t;
    $[95] = t34;
  } else {
    t34 = $[95];
  }
  let t35;
  if ($[96] !== t) {
    t35 = t(_temp35);
    $[96] = t;
    $[97] = t35;
  } else {
    t35 = $[97];
  }
  let t36;
  if ($[98] !== t) {
    t36 = t(_temp36);
    $[98] = t;
    $[99] = t36;
  } else {
    t36 = $[99];
  }
  let t37;
  if ($[100] !== t) {
    t37 = t(_temp37);
    $[100] = t;
    $[101] = t37;
  } else {
    t37 = $[101];
  }
  let t38;
  if ($[102] !== t) {
    t38 = t(_temp38);
    $[102] = t;
    $[103] = t38;
  } else {
    t38 = $[103];
  }
  let t39;
  if ($[104] !== t) {
    t39 = t(_temp39);
    $[104] = t;
    $[105] = t39;
  } else {
    t39 = $[105];
  }
  let t40;
  if ($[106] !== t) {
    t40 = t(_temp40);
    $[106] = t;
    $[107] = t40;
  } else {
    t40 = $[107];
  }
  let t41;
  if ($[108] !== t) {
    t41 = t(_temp41);
    $[108] = t;
    $[109] = t41;
  } else {
    t41 = $[109];
  }
  let t42;
  if ($[110] !== t) {
    t42 = t(_temp42);
    $[110] = t;
    $[111] = t42;
  } else {
    t42 = $[111];
  }
  let t43;
  if ($[112] !== t) {
    t43 = t(_temp43);
    $[112] = t;
    $[113] = t43;
  } else {
    t43 = $[113];
  }
  let t44;
  if ($[114] !== t) {
    t44 = t(_temp44);
    $[114] = t;
    $[115] = t44;
  } else {
    t44 = $[115];
  }
  let t45;
  if ($[116] !== t) {
    t45 = t(_temp45);
    $[116] = t;
    $[117] = t45;
  } else {
    t45 = $[117];
  }
  let t46;
  if ($[118] !== t) {
    t46 = t(_temp46);
    $[118] = t;
    $[119] = t46;
  } else {
    t46 = $[119];
  }
  let t47;
  if ($[120] !== t) {
    t47 = t(_temp47);
    $[120] = t;
    $[121] = t47;
  } else {
    t47 = $[121];
  }
  let t48;
  if ($[122] !== t) {
    t48 = t(_temp48);
    $[122] = t;
    $[123] = t48;
  } else {
    t48 = $[123];
  }
  let t49;
  if ($[124] !== t) {
    t49 = t(_temp49);
    $[124] = t;
    $[125] = t49;
  } else {
    t49 = $[125];
  }
  let t50;
  if ($[126] !== t) {
    t50 = t(_temp50);
    $[126] = t;
    $[127] = t50;
  } else {
    t50 = $[127];
  }
  let t51;
  if ($[128] !== t) {
    t51 = t(_temp51);
    $[128] = t;
    $[129] = t51;
  } else {
    t51 = $[129];
  }
  let t52;
  if ($[130] !== t) {
    t52 = t(_temp52);
    $[130] = t;
    $[131] = t52;
  } else {
    t52 = $[131];
  }
  let t53;
  if ($[132] !== t) {
    t53 = t(_temp53);
    $[132] = t;
    $[133] = t53;
  } else {
    t53 = $[133];
  }
  let t54;
  if ($[134] !== t) {
    t54 = t(_temp54);
    $[134] = t;
    $[135] = t54;
  } else {
    t54 = $[135];
  }
  let t55;
  if ($[136] !== t28 || $[137] !== t29 || $[138] !== t30 || $[139] !== t31 || $[140] !== t32 || $[141] !== t33 || $[142] !== t34 || $[143] !== t35 || $[144] !== t36 || $[145] !== t37 || $[146] !== t38 || $[147] !== t39 || $[148] !== t40 || $[149] !== t41 || $[150] !== t42 || $[151] !== t43 || $[152] !== t44 || $[153] !== t45 || $[154] !== t46 || $[155] !== t47 || $[156] !== t48 || $[157] !== t49 || $[158] !== t50 || $[159] !== t51 || $[160] !== t52 || $[161] !== t53 || $[162] !== t54) {
    t55 = {
      collect_custom_data: t28,
      investor_profile: t29,
      identity_data: t30,
      business_data: t31,
      conditional: t32,
      rules: t33,
      custom_document: t34,
      identity_document: t35,
      selfie: t36,
      verification_check: t37,
      verified_prefill: t38,
      action: t39,
      branch: t40,
      external_api: t41,
      bank_link: t42,
      authentication: t43,
      collect_card_data: t44,
      assign_data: t45,
      common_expression: t46,
      code_exec: t47,
      document_extraction: t48,
      watchlist_review: t49,
      prerequisite: t50,
      output: t51,
      complete: t52,
      ai_research: t53,
      ai_decision: t54
    };
    $[136] = t28;
    $[137] = t29;
    $[138] = t30;
    $[139] = t31;
    $[140] = t32;
    $[141] = t33;
    $[142] = t34;
    $[143] = t35;
    $[144] = t36;
    $[145] = t37;
    $[146] = t38;
    $[147] = t39;
    $[148] = t40;
    $[149] = t41;
    $[150] = t42;
    $[151] = t43;
    $[152] = t44;
    $[153] = t45;
    $[154] = t46;
    $[155] = t47;
    $[156] = t48;
    $[157] = t49;
    $[158] = t50;
    $[159] = t51;
    $[160] = t52;
    $[161] = t53;
    $[162] = t54;
    $[163] = t55;
  } else {
    t55 = $[163];
  }
  const pasteTranslations = t55;
  let t56;
  if ($[164] !== getNodeContext || $[165] !== pasteTranslations || $[166] !== t || $[167] !== updateTranslations) {
    const translateOperation = op => {
      if (!("kind" in op)) {
        return t(_temp55);
      }
      if (op.kind === "add_node") {
        if (!("nodeKind" in op)) {
          return t(_temp56);
        }
        const kind = op.nodeKind as NewNodeKind;
        const {
          title
        } = getNodeContext(kind);
        return t(_temp57, {
          kind: title.toLowerCase()
        });
      }
      if (op.kind === "update_node") {
        if (!("nodeData" in op) || !(op.nodeData.kind in updateTranslations)) {
          return t(_temp58);
        }
        const kind_0 = op.nodeData.kind as NodeDataUpdate['kind'];
        return t(_temp59, {
          kind: updateTranslations[kind_0].toLowerCase()
        });
      }
      if (op.kind === "paste_node") {
        if (!("nodes" in op) || !(op.nodes[0]?.kind in pasteTranslations)) {
          return t(_temp60);
        }
        const kind_1 = op.nodes[0]?.kind as AddNodeKinds;
        if (op.nodes.length === 1) {
          return t(_temp61, {
            kind: pasteTranslations[kind_1].toLowerCase()
          });
        }
        return t(_temp62);
      }
      if (op.kind === "remove_node") {
        return t(_temp63);
      }
      if (op.kind === "replace_graph") {
        return t(_temp64);
      }
      if (op.kind === "update_settings") {
        return t(_temp65);
      }
      return t(_temp66);
    };
    t56 = {
      translateOperation
    };
    $[164] = getNodeContext;
    $[165] = pasteTranslations;
    $[166] = t;
    $[167] = updateTranslations;
    $[168] = t56;
  } else {
    t56 = $[168];
  }
  return t56;
};
function _temp($) {
  return $.addNode.nodes.customDocument;
}
function _temp2($_0) {
  return $_0.addNode.nodes.collectCustomData;
}
function _temp3($_1) {
  return $_1.addNode.nodes.collectIdentityData;
}
function _temp4($_2) {
  return $_2.addNode.nodes.collectBusinessData;
}
function _temp5($_3) {
  return $_3.addNode.nodes.conditionalSubtree;
}
function _temp6($_4) {
  return $_4.addNode.nodes.rules;
}
function _temp7($_5) {
  return $_5.addNode.nodes.identityDocument;
}
function _temp8($_6) {
  return $_6.addNode.nodes.selfie;
}
function _temp9($_7) {
  return $_7.addNode.nodes.verificationCheck;
}
function _temp10($_8) {
  return $_8.addNode.nodes.action;
}
function _temp11($_9) {
  return $_9.addNode.nodes.branch;
}
function _temp12($_10) {
  return $_10.addNode.nodes.externalApi;
}
function _temp13($_11) {
  return $_11.addNode.nodes.collectBankData;
}
function _temp14($_12) {
  return $_12.addNode.nodes.authentication;
}
function _temp15($_13) {
  return $_13.addNode.nodes.collectCardData;
}
function _temp16($_14) {
  return $_14.addNode.nodes.assignData;
}
function _temp17($_15) {
  return $_15.addNode.nodes.commonExpression;
}
function _temp18($_16) {
  return $_16.addNode.nodes.codeExecution;
}
function _temp19($_17) {
  return $_17.addNode.nodes.documentExtraction;
}
function _temp20($_18) {
  return $_18.operations.update.addDefaultRules;
}
function _temp21($_19) {
  return $_19.operations.update.removeRulesForCategory;
}
function _temp22($_20) {
  return $_20.addNode.nodes.prerequisite;
}
function _temp23($_21) {
  return $_21.addNode.nodes.output;
}
function _temp24($_22) {
  return $_22.addNode.nodes.complete;
}
function _temp25($_23) {
  return $_23.addNode.nodes.aiResearch;
}
function _temp26($_24) {
  return $_24.addNode.nodes.aiDecision;
}
function _temp27($_25) {
  return $_25.addNode.nodes.verifiedPrefill;
}
function _temp28($_26) {
  return $_26.addNode.nodes.collectCustomData;
}
function _temp29($_27) {
  return $_27.addNode.nodes.investorProfile;
}
function _temp30($_28) {
  return $_28.addNode.nodes.collectIdentityData;
}
function _temp31($_29) {
  return $_29.addNode.nodes.collectBusinessData;
}
function _temp32($_30) {
  return $_30.addNode.nodes.conditional;
}
function _temp33($_31) {
  return $_31.addNode.nodes.rules;
}
function _temp34($_32) {
  return $_32.addNode.nodes.customDocument;
}
function _temp35($_33) {
  return $_33.addNode.nodes.identityDocument;
}
function _temp36($_34) {
  return $_34.addNode.nodes.selfie;
}
function _temp37($_35) {
  return $_35.addNode.nodes.verificationCheck;
}
function _temp38($_36) {
  return $_36.addNode.nodes.verifiedPrefill;
}
function _temp39($_37) {
  return $_37.addNode.nodes.action;
}
function _temp40($_38) {
  return $_38.addNode.nodes.branch;
}
function _temp41($_39) {
  return $_39.addNode.nodes.externalApi;
}
function _temp42($_40) {
  return $_40.addNode.nodes.collectBankData;
}
function _temp43($_41) {
  return $_41.addNode.nodes.authentication;
}
function _temp44($_42) {
  return $_42.addNode.nodes.collectCardData;
}
function _temp45($_43) {
  return $_43.addNode.nodes.assignData;
}
function _temp46($_44) {
  return $_44.addNode.nodes.commonExpression;
}
function _temp47($_45) {
  return $_45.addNode.nodes.codeExecution;
}
function _temp48($_46) {
  return $_46.addNode.nodes.documentExtraction;
}
function _temp49($_47) {
  return $_47.addNode.nodes.watchlistReview;
}
function _temp50($_48) {
  return $_48.addNode.nodes.prerequisite;
}
function _temp51($_49) {
  return $_49.addNode.nodes.output;
}
function _temp52($_50) {
  return $_50.addNode.nodes.complete;
}
function _temp53($_51) {
  return $_51.addNode.nodes.aiResearch;
}
function _temp54($_52) {
  return $_52.addNode.nodes.aiDecision;
}
function _temp55($_53) {
  return $_53.operations.general;
}
function _temp56($_54) {
  return $_54.operations.addNodeGeneral;
}
function _temp57($_55) {
  return $_55.operations.addNode;
}
function _temp58($_56) {
  return $_56.operations.updateNodeGeneral;
}
function _temp59($_57) {
  return $_57.operations.updateNode;
}
function _temp60($_58) {
  return $_58.operations.pasteNodeGeneral;
}
function _temp61($_59) {
  return $_59.operations.pasteNode;
}
function _temp62($_60) {
  return $_60.operations.pasteMultipleNodes;
}
function _temp63($_61) {
  return $_61.operations.removeNode;
}
function _temp64($_62) {
  return $_62.operations.replaceGraph;
}
function _temp65($_63) {
  return $_63.operations.updateSettings;
}
function _temp66($_64) {
  return $_64.operations.general;
}